module.exports = __webpack_public_path__ + "img/UTMILL.423306d2.png";